/* eslint-disable */
import { produce } from "immer";
import {
  NOTIFICATION_FETCH_START,
  NOTIFICATION_FETCH_SUCCESS,
  NOTIFICATION_FETCH_FAILURE,
} from "../actions/types";

const pushNotifications = (
  state = {
    notificationFetching: false,
    notificationData: {},
    notificationError: null,
  },
  action,
) => {
  switch (action.type) {
    case NOTIFICATION_FETCH_START:
      return produce(state, (draft) => {
        draft.notificationFetching = true;
      });
    case NOTIFICATION_FETCH_SUCCESS:
      return produce(state, (draft) => {
        draft.notificationFetching = true;
        draft.notificationData = action.data;
        draft.notificationFetching = false;
      });
    case NOTIFICATION_FETCH_FAILURE:
      return produce(state, (draft) => {
        draft.notificationFetching = false;
        draft.notificationError = action.error;
      });
    default:
      return state;
  }
};

export default pushNotifications;
